import React, { useEffect } from 'react';

import { connect, useSelector } from 'react-redux';

import { actions } from '../redux/ProductReducer';
import { Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import ProductTemplateBox from '../components/ProductTemplateBox/ProductTemplateBox';
import DocumentPacksForm from '../components/DocumentPacks/DocumentPacksForm';
import getIncludedResource from '../../../helpers/getIncludedResource';
import { ICON_MAP } from '../../../common/components/SvgIcons/productIcons';

const DocumentPacksEditContainer = ({ params, updateDocumentPacks, getProduct }) => {
  const { product, isLoading } = useSelector((state) => state.productManagement);

  const currentProductId = product?.data?.id;

  const { productId } = params;

  useEffect(
    () => {
      getProduct(productId, ['document_packs', 'document_packs.scheme_documents']);
    },
    [productId, getProduct],
  );

  const handleUpdateProduct = (formValues) => {
    const newValues = {
      data: formValues.filter((docPack) => !!docPack.relationships?.scheme_documents),
    };

    return updateDocumentPacks(newValues, productId);
  };

  if (!currentProductId || currentProductId !== productId || isLoading) {
    return (
      <InternalContainer title={'Product Management'}>
        <Loader />
      </InternalContainer>
    );
  }

  const documentPacks = getIncludedResource(
    product.data,
    product.included,
    'document_packs',
  );

  const isReady = Array.isArray(documentPacks?.data);

  const productCode = product.data.attributes.product_code;
  const productName = product.data.attributes.name;

  return (
    <InternalContainer title={'Product Management'}>
      <ProductTemplateBox
        product={product.data}
        productIcon={ICON_MAP[productCode]}
        productName={productName}
      >
        {!isReady && (
          <DocumentPacksForm
            product={product.data}
            onUpdateDocumentPack={handleUpdateProduct}
            documentPacks={documentPacks}
          />
        )}
      </ProductTemplateBox>
    </InternalContainer>
  );
};

export default connect(
  null,
  {
    updateDocumentPacks: actions.updateDocumentPacks,
    getProduct: actions.getProduct,
  },
)(DocumentPacksEditContainer);
